import styled from '@emotion/styled';

export const Wrapper = styled.div`
  margin-bottom: 300px;
`;

export const InputLabelSpan = styled.span`
  color: ${(props) => props.theme.color.blue.default};
  font-size: 14px;
  font-weight: 600;
  margin-left: 8px;
`;

export const ProfilePictureWrapper = styled.div`
  height: 200px;
  width: 200px;
`;

export const SingleFileWrapper = styled.div`
  width: 100%;
  height: 130px;
`;

export const MultipleFilesWrapper = styled.div`
  width: 100%;
  min-height: 130px;
`;

export const MultiFileViewer = styled.div`
  display: flex;
  flex-direction: column;
`;
